import React from 'react';
import cx from 'classnames';
import FooterProps from './Footer.types';
import styles from './Footer.module.scss';
import Link from '../../atoms/Link';
import ParsedText from '../../atoms/ParsedText';
import LinkProps from '../../atoms/Link/Link.types';
import { StyleSheetColor } from '../../shared/types/styleSheetColors.types';
import { TextColor, TextColorType } from '../../shared/types/textColor.types';

const renderSingleColumnLayout = (text: string, links: LinkProps[], fontColor: TextColorType): JSX.Element => {
  return (
    <>
      <ParsedText
        textProps={{
          color: fontColor,
          sizing: 'small',
          className: styles.textWrapper,
        }}
        htmlString={text}
      />
      <div className={styles.links}>
        {links?.map((link) => (
          <Link key={`${link.href}-${link.children}`} fontColor={fontColor} {...link} />
        ))}
      </div>
    </>
  );
};

const renderTwoColumnLayout = (text: string, links: LinkProps[], fontColor: TextColorType): JSX.Element => {
  return (
    <div className={styles.footerRow}>
      <div className={styles.footerText}>
        <ParsedText
          textProps={{
            color: fontColor,
            sizing: 'small',
            className: styles.textWrapper,
          }}
          htmlString={text}
        />
      </div>
      <div className={styles.footerLinks}>
        <div className={styles.links}>
          {links?.map((link) => (
            <Link key={`${link.href}-${link.children}`} fontColor={fontColor} {...link} />
          ))}
        </div>
      </div>
    </div>
  );
};

const Footer = (props: FooterProps) => {
  const {
    text,
    links,
    preText,
    fontColor = TextColor.Primary,
    backgroundColor = StyleSheetColor.Tint,
    twoColumnLayout = false,
    linksOnTop = false,
  } = props;

  return (
    <div className={cx(styles.footer, styles[backgroundColor])}>
      <div className={cx(styles.preTextWrapper)}>
        {preText && (
          <ParsedText
            textProps={{
              color: fontColor,
              sizing: 'small',
              className: styles.textWrapper,
            }}
            htmlString={preText}
          />
        )}
      </div>
      <div className={cx(styles.innerWrapper, { [styles.innerWrapperReverse]: linksOnTop })}>
        {twoColumnLayout === false && renderSingleColumnLayout(text, links, fontColor)}
        {twoColumnLayout && renderTwoColumnLayout(text, links, fontColor)}
      </div>
    </div>
  );
};

export default Footer;
